import registrationInstance from '../instance'

const getChangeSetting = (module, businessScope) => {
  return registrationInstance.get(`/company/changeSettings/${module}/${businessScope}`)
}

export default getChangeSetting
